import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock,
    BlockType,
    SettingType,
    ValidationMessage,
    ValidationMessageType,
    SettingState,
    TibboDataType,
    FlowEdge,
    IOLinesMode,
    IOMode,
} from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_00_1 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_00_1';
        this.name = 'Tibbit 00_1';
        this.lines = 4;
        this.mode = IOMode.IO;
        this.initLines();
    }
}
